var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTokenUnlock = function SvgTokenUnlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    stroke: "#ffffff",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "transactions")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.922,37.056Q59,36.038,59,35A27,27,0,0,0,37.961,8.668",
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 6,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.314,10.685A27,27,0,0,0,6.208,43.007",
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 6,
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.778,57.288a26.968,26.968,0,0,0,35.044-3.962",
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.617,
    cy: 48.5,
    r: 6,
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.383,
    cy: 48.5,
    r: 6,
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    "data-color": "color-2"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTokenUnlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tokenUnlock.d530bbfd.svg";
export { ForwardRef as ReactComponent };